<!-- BANNER VARIANT (for dashboard) -->
<div class="expiry-banner d-flex align-items-center justify-content-between">
  <div class="expiry-banner__left d-flex align-items-center gap-8">
    <img src="/assets/images/warning-white.svg" alt="warning" class="expiry-banner__icon" />
    <span class="expiry-banner__text">{{ expiredLabel }}</span>
  </div>
  @if (loading) {
    <div class="expiry-banner__right d-flex align-items-center gap-8" role="status" aria-live="polite">
      <span class="expiry-banner__spinner" aria-hidden="true"></span>
      <span class="expiry-banner__text">{{ loadingLabel }}...</span>
    </div>
  } @else if (expiryDate && formattedDueDate) {
    <div class="expiry-banner__right">
      <span class="expiry-banner__text">{{ dueLabel }} {{ formattedDueDate }}</span>
    </div>
  }
</div>
